import React from 'react';
import Modal from './Modal';
import './HowItWorksModal.css';

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowItWorksModal: React.FC<HowItWorksModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="How 2 Play"
      className="how-it-works-modal"
    >
      <div className="how-it-works-content">
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Launch a Token</h3>
              <p>Protocol adds 80% liquidity to your contribution to seed a new token launch</p>
              <p className="step-subtext">
                Your entry creates real market liquidity
              </p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Race for Allocation</h3>
              <p>Pick winning tokens in 15-second races to increase your token allocation</p>
              <p className="step-subtext">
                Real-time price data powered by Pyth Network
              </p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Claim Your Tokens</h3>
              <p>Sell your allocation anytime on the open market</p>
            </div>
          </div>
        </div>

      </div>
    </Modal>
  );
};

export default HowItWorksModal;
